import React from "react";

function CurrentYear() {
  return (<>{new Date().getFullYear()}</>);
}

export default CurrentYear;